import { INotification } from './notification-factory.service';
import { inject, Injectable } from '@angular/core';
import { PushNotificationService } from './push-notification.service';
import { MessageTemplate } from '../../models/enums/enums';
import { EssayPilotService } from '../essay-pilot/essay-pilot.service';

@Injectable({
  providedIn: 'root'
})
export class EssaySubmissionNotificationService implements INotification {
  constructor(
    private pushNotificationService: PushNotificationService,
    private essayPilotService: EssayPilotService
  ) {}

  notify(message:string,data: { [key: string]: any }): void {
    this.pushNotificationService.pushNotification(message,MessageTemplate.EssaySubmission, data);
    this.essayPilotService.essayAnswerSubmission$.next(data['essayAnswerResponse']);
  }
}
